import { render, staticRenderFns } from "./ExtPageLayout.vue?vue&type=template&id=6c3bffe5&scoped=true"
import script from "./ExtPageLayout.vue?vue&type=script&lang=js"
export * from "./ExtPageLayout.vue?vue&type=script&lang=js"
import style0 from "./ExtPageLayout.vue?vue&type=style&index=0&id=6c3bffe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3bffe5",
  null
  
)

export default component.exports